import { useEffect } from 'react'

import { useOnboardingFormContext } from '../contexts/OnboardingFormContext'
import { OnboardingStepRegistration } from '../types/onboardingStepRegistration'

export const useRegisterOnboardingStep = (registration: OnboardingStepRegistration) => {
  const { registerStep } = useOnboardingFormContext()
  const { isLoading, isSubmitting, predefinedValues, submitHandler } = registration

  useEffect(() => {
    registerStep({ isLoading, isSubmitting, predefinedValues, submitHandler })
  }, [isLoading, isSubmitting, predefinedValues, submitHandler, registerStep])
}
